import type { SectionId } from '~/types/sectionId';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { warnOnDuplicateSectionIds } from '~/utils/sectionRegistryValidation';

export function findSectionConfigById(
    registry: StoryblokConfigSlug[] | null | undefined,
    country: string,
    sectionId: SectionId
): StoryblokConfigSlug | null {
    const matchingConfigs = registry?.filter((config) => config.country === country && config.sectionId === sectionId);

    if (matchingConfigs) {
        warnOnDuplicateSectionIds(matchingConfigs, 'Ambiguous section ID lookup; using first matching config', {
            country,
            sectionId
        });
    }

    return matchingConfigs?.[0] ?? null;
}
